import type { HelpFile } from '../../types/help'
import { RestrictionRulesTestIds } from '../../../testids/RestrictionRulesTestIds'

export const restrictionRulesHelp: HelpFile = {
  docPage: '/docs/access-governance/restriction-rules',
  texts: {
    [RestrictionRulesTestIds.restrictionRulesList]:
      'All Restriction Rules defined in the system — each rule names Access Profiles that must not coexist on the same identity, covering separation-of-duty and conflict-of-interest policies.',
    [RestrictionRulesTestIds.btnDetectionHistory]:
      'History of every detection run: when each rule was evaluated and which violations were found.',
    [RestrictionRulesTestIds.colViolations]:
      'Number of identities currently violating this Restriction Rule.',
  },
}
